export const YM_ECOM_ID = Number(process.env.REACT_APP_YM_ID || 0);

/* ---------------- 3+ товаров ---------------- */
const THREE_PLUS_MIN_PRICE_ENV = Number(process.env.REACT_APP_THREE_PLUS_DISCOUNT_MIN_PRICE || '2000');
export const THREE_PLUS_MIN_PRICE = Number.isFinite(THREE_PLUS_MIN_PRICE_ENV) && THREE_PLUS_MIN_PRICE_ENV > 0 ? THREE_PLUS_MIN_PRICE_ENV : 2000;
const THREE_PLUS_DISCOUNT_PERCENT_ENV = Number(process.env.REACT_APP_THREE_PLUS_DISCOUNT_PERCENT || '25');
export const THREE_PLUS_DISCOUNT_PERCENT =
    Number.isFinite(THREE_PLUS_DISCOUNT_PERCENT_ENV) && THREE_PLUS_DISCOUNT_PERCENT_ENV > 0 && THREE_PLUS_DISCOUNT_PERCENT_ENV <= 75
        ? THREE_PLUS_DISCOUNT_PERCENT_ENV
        : 25;
export const THREE_PLUS_ENABLED_FLAG = String(process.env.REACT_APP_THREE_PLUS_DISCOUNT_ENABLED || '').toLowerCase() === 'true';
export const THREE_PLUS_UNTIL = process.env.REACT_APP_THREE_PLUS_DISCOUNT_UNTIL || '';

/* ---------------- Вторая подушка -50% ---------------- */
const SECOND_PILLOW_MIN_PRICE_ENV = Number(process.env.REACT_APP_SECOND_PILLOW_DISCOUNT_MIN_PRICE || '2000');
export const SECOND_PILLOW_MIN_PRICE = Number.isFinite(SECOND_PILLOW_MIN_PRICE_ENV) && SECOND_PILLOW_MIN_PRICE_ENV > 0 ? SECOND_PILLOW_MIN_PRICE_ENV : 2000;
const SECOND_PILLOW_DISCOUNT_PERCENT_ENV = Number(process.env.REACT_APP_SECOND_PILLOW_DISCOUNT_PERCENT || '50');
export const SECOND_PILLOW_DISCOUNT_PERCENT =
    Number.isFinite(SECOND_PILLOW_DISCOUNT_PERCENT_ENV) && SECOND_PILLOW_DISCOUNT_PERCENT_ENV > 0 && SECOND_PILLOW_DISCOUNT_PERCENT_ENV <= 75
        ? SECOND_PILLOW_DISCOUNT_PERCENT_ENV
        : 50;
export const SECOND_PILLOW_ENABLED_FLAG = String(process.env.REACT_APP_SECOND_PILLOW_DISCOUNT_ENABLED || '').toLowerCase() === 'true';
export const SECOND_PILLOW_UNTIL = process.env.REACT_APP_SECOND_PILLOW_DISCOUNT_UNTIL || '';
export const SECOND_PILLOW_CATEGORY_URL = String(process.env.REACT_APP_SECOND_PILLOW_DISCOUNT_CATEGORY_URL || '')
    .trim()
    .toLowerCase();

/* ---------------- Бесплатная доставка (DTL) ---------------- */
export const FREE_DELIVERY_MIN_TOTAL = 10_000;
export const ACTIVATING_DISCOUNT_MANAGEMENT = true; // активация скидки в ДР и списания бонусов (фронт)
export const FREE_DELIVERY_ZONES_MO = new Set<string>([
    'Звенигород',
    'Львовский',
    'Павловский Посад',
    'Красноармейск',
    'Софрино',
    'Дмитров',
    'Сергиев Посад',
    'Солнечногорск',
    'Истра',
    'Некрасовский',
    'Лобня',
    'Долгопрудный',
    'Пушкино',
    'Мытищи',
    'Щелково',
    'Лосино-Петровский',
    'Ногинск',
    'Балашиха',
    'Реутов',
    'Электросталь',
    'Железнодорожный',
    'Люберцы',
    'Жуковский',
    'Раменское',
    'Лыткарино',
    'Видное',
    'Бронницы',
    'Домодедово',
    'Востряково',
    'Климовск',
    'Подольск',
    'Апрелевка',
    'Краснознаменск',
    'Одинцово',
    'Красногорск',
    'Нахабино',
    'Химки',
    'Хотьково',
    'Новое Гришино',
    'Деденево',
    'Яхрома',
]);
